<div class="modal-header">
  <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true"><i class="fas fa-times"></i></span>
  </button>
</div>
<div class="modal-body">
  <img [src]="image" />
</div>
